function LineSpacer() {
  return (
    <div className='py-4 grid place-items-center w-full'>
      <div className='border-b-2 border-gray-700 w-40'></div>
    </div>
  );
}

export default LineSpacer;
